exports = module.exports = require("../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".custom-tooltip__activator{cursor:pointer}", ""]);

// exports
